import React, {lazy, Suspense} from 'react'

const DiaryEntryLazy = lazy(() =>
    import('./DiaryEntry')
)

const DiaryEntry = props => (
    <Suspense fallback={null}>
        <DiaryEntryLazy {...props} />
    </Suspense>
)

export default DiaryEntry
